import { config } from "../config/app.config";

// Backend mounts uploaded files under "/static" (sibling of the "/api" prefix),
// while resource_path values stored in the DB start with "uploads/".
const backendOrigin = config.apiUrl.replace(/\/api\/?$/, "");

export const toStaticResourceUrl = (relativePath: string | null | undefined): string | null => {
    if (!relativePath) return null;

    let sanitized = relativePath.replace(/^\/+/, "").replace(/\\/g, "/");
    if (sanitized.startsWith("uploads/")) {
        sanitized = sanitized.slice("uploads/".length);
    }

    return `${backendOrigin}/static/${sanitized}`;
};
